import {
  filter,
  trim,
  join,
  map,
  intersection,
  concat,
  keys,
  kebabCase
} from 'lodash'

const visible = (props) => {
  const allowedModifiers = ['xs', 'sm', 'md', 'lg', 'inline']

  return bemClasses('visible', allowedModifiers, props)
}

const hidden = (props) => {
  const allowedModifiers = ['xs', 'sm', 'md', 'lg']

  return bemClasses('hidden', allowedModifiers, props)
}

const spacing = (props) => {
  const allowedModifiers = [
    'left', 'right', 'top', 'bottom', // Sides
    'all', 'horizontal', 'vertical', // Groups
    'half', 'large', 'extraLarge', 'huge', // Sizes
    'block', 'padding' // Display
  ]

  return bemClasses('spacing', allowedModifiers, props)
}

export const bemClasses = (baseClass, allowedModifiers, props, className = '') => {
  let activeKeys = filter(keys(props), (key) => !!props[key])

  let modifiers = map(intersection(activeKeys, allowedModifiers), (modifier) => {
    return `${baseClass}--${kebabCase(modifier)}`
  })

  let visibleModifiers = props.visible ? visible(props.visible) : []
  let hiddenModifiers = props.hidden ? hidden(props.hidden) : []
  let spacingModifiers = props.spacing ? spacing(props.spacing) : []

  let allClasses = concat(
    [baseClass],
    modifiers,
    visibleModifiers,
    hiddenModifiers,
    spacingModifiers,
    [className]
  )

  return trim(join(allClasses, ' '))
}
